import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// API helper with auth
export const apiCall = async (method, endpoint, data = null, token = null) => {
  const config = {
    method,
    url: `${API}${endpoint}`,
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  };
  if (data) config.data = data;
  const res = await axios(config);
  return res.data;
};

export default axios;
